import { ComponentProps, ReactNode, useState } from 'react'
import { Trans } from 'react-i18next'

import { AccordionItem, AccordionItemIndicator, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Container } from '@/components/ui/container'
import { Flex } from '@/components/ui/flex'
import { Link } from '@/components/ui/link'
import { Separator } from '@/components/ui/separator'
import { Text } from '@/components/ui/typography'
import { IShortMessageObject } from '@/types/gigiChat/Chat'

const Disclaimer = ({ item }: { item: IShortMessageObject }) => {
    const processingStrategy = item.settings?.processingStrategy

    const [accordionValue, setAccordionValue] = useState<string[]>([])

    let short: ReactNode
    let long: ReactNode
    if (processingStrategy === 'QA') {
        short = <Trans i18nKey={'global.csi.descriptions.qa.textOutput.short'} components={{ bold: <b /> }} />
        long = <Trans i18nKey={'global.csi.descriptions.qa.textOutput.long'} components={{ bold: <b /> }} />
    } else if (processingStrategy === 'DocAnalysis') {
        short = <Trans i18nKey={'global.csi.descriptions.docAnalysis.textOutput.short'} components={{ bold: <b /> }} />
        long = <Trans i18nKey={'global.csi.descriptions.docAnalysis.textOutput.long'} components={{ bold: <b /> }} />
    } else if (processingStrategy === 'Writing') {
        if (item.settings?.processingStrategyWriting.model === 'bing-grounding') {
            short = <Trans i18nKey={'global.csi.descriptions.writingWebSearch.textOutput.short'} />
            long = (
                <Trans
                    i18nKey={'global.csi.descriptions.writingWebSearch.textOutput.long'}
                    components={{
                        bold: <b />,
                        link1: (
                            <Link
                                href="https://gsk-qualitysuite.veevavault.com/ui/#permalink=V0Z000000050030"
                                isExternal
                                key="https://gsk-qualitysuite.veevavault.com/ui/#permalink=V0Z000000050030"
                                textDecoration="underline"
                            />
                        ),
                    }}
                />
            )
        } else {
            short = <Trans i18nKey={'global.csi.descriptions.writing.textOutput.short'} components={{ bold: <b /> }} />
            long = <Trans i18nKey={'global.csi.descriptions.writing.textOutput.long'} components={{ bold: <b /> }} />
        }
    } else if (processingStrategy === 'Translation') {
        short = <Trans i18nKey={'global.csi.descriptions.translationMode.textOutput.short'} components={{ bold: <b /> }} />
        long = <Trans i18nKey={'global.csi.descriptions.translationMode.textOutput.long'} components={{ bold: <b /> }} />
    } else {
        return
    }

    const onAccordionValueChange: NonNullable<ComponentProps<typeof AccordionRoot>['onValueChange']> = (details) => {
        setAccordionValue(details.value)
    }

    const isExpanded = accordionValue.includes('expanded')

    return (
        <Container variant="citations" pb="0" maxWidth="unset" data-testid="chat-disclaimer">
            <Separator orientation="horizontal" />
            <AccordionRoot multiple value={accordionValue} onValueChange={onAccordionValueChange}>
                <AccordionItem border="none" py="12px" value="expanded">
                    <AccordionItemTrigger
                        _hover={{
                            background: 'transparent',
                        }}
                        alignItems="center"
                        justifyContent="space-between"
                        p="0"
                        indicatorPlacement="none"
                    >
                        <Flex alignItems="start" gap="12px">
                            {isExpanded ? (
                                <Text data-testid="disclaimer-long-text" fontSize="12px" textAlign="left">
                                    {long}
                                </Text>
                            ) : (
                                <Text data-testid="disclaimer-short-text" fontSize="12px">
                                    {short}
                                </Text>
                            )}
                            <AccordionItemIndicator alignSelf={isExpanded ? 'top' : 'center'} />
                        </Flex>
                    </AccordionItemTrigger>
                </AccordionItem>
            </AccordionRoot>
        </Container>
    )
}

export default Disclaimer
